export const storageKey = {
  token: 'token',
  tokenType: 'tokenType',
  refreshToken: 'refreshToken',
  deviceId: 'deviceId',
  userProfile: 'userProfile',
  instituteSessionList: 'instituteSessionList',
  selectedInstitute: 'selectedInstitute',
  navigationMenu: 'navigationMenu',
  enumData: 'enumData',
  studentEnumData: 'studentEnumData',
  admissionEnumData: 'admissionEnumData',
  instituteEnumData: 'instituteEnumData',
  employeeEnumData: 'employeeEnumData',
  transportationEnumData: 'transportationEnumData',
  cityState: 'cityStateData',
  instituteData: 'instituteData',
  notifications: 'notifications',
};
